import React, { useEffect, useState } from "react";
import useHttp from "../../../../hooks/use-http";

import { toast } from "react-toastify";
import Pagination from "../../../../components/Pagination";
import { Modal as AntModal, Spin } from "antd";

import Modal from "react-modal";

const CleaningWashingListview = (props) => {
  const [loginUserId, setLoginUserId] = useState(localStorage.getItem("id"));
  const [canAdd, setCanAdd] = useState("none");
  const [canEdit, setCanEdit] = useState("none");
  const [canDelete, setCanDelete] = useState("none");
  const [canPdf, setCanPdf] = useState("none");
  const [canView, setCanView] = useState("none");
  const [serviceId, setServiceId] = useState("none");

  useEffect(() => {
    var urlpathname = window.location.pathname;
    var roleAllocation = JSON.parse(localStorage.getItem("RoleAllocation"));

    if (roleAllocation && roleAllocation.length > 0) {
      //console.log("roleAllocation", roleAllocation);

      var roleAllocationFilterList = roleAllocation.filter(
        (item) => item.serviceUrl == urlpathname
      );
      //console.log("roleAllocationFilterList", roleAllocationFilterList);
      if (roleAllocationFilterList && roleAllocationFilterList.length > 0) {
        var itemselected = roleAllocationFilterList[0];

        console.log(itemselected);

        setServiceId(itemselected.serviceId);
        if (itemselected.canAddStatus == true) {
          setCanAdd("block");
        }

        if (itemselected.canEditStatus == true) {
          setCanEdit("block");
        }

        if (itemselected.canDeleteStatus == true) {
          setCanDelete("block");
        }
        if (itemselected.canViewStatus == true) {
          setCanView("block");
        }

        if (itemselected.canPdfStatus == true) {
          setCanPdf("block");
        }
        //console.log("canAdd", canAdd);
      }
    }
  }, []);
  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
    },
    content: {
      top: "55%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "700px", // Adjust the width as needed
      height: "80%",
      minHeight: "450px",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [productDetails, setProductDetails] = useState([]);

  const { sendRequest: getcleaningWashing } = useHttp();

  const openModal = (data) => {
    setSelectedData(data);
    setIsModalOpen(true);
    const id = (data && data.cleaningWashingId) || "";
    //console.log(id);

    getcleaningWashing(
      {
        url: `/api/cleaningWashing/?cleaningWashingId=${id}`,
      },
      (res) => {
        //console.log(res);
        setProductDetails(res.productDetail);
      }
    );
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const { addForm, update, sId } = props;
  const [data, setData] = useState([]);
  const [cwData, setCwData] = useState([]);
  const [allData, setAllData] = useState([]);

  const getData = () => {
    getcleaningWashing(
      {
        url: "/api/cleaningWashing/",
      },
      (res) => {
        if (res) {
          //console.log(res);
          const sortedData = res.sort(
            (a, b) => b.cleaningWashingId - a.cleaningWashingId
          );
          setData(sortedData);

          setAllData(res);
          setCwData(res[0]);
        }
      }
    );
  };

  useEffect(() => {
    getData();
  }, []);

  const handleSearch = (e) => {
      var filetrtext = e.target.value.trim().toLowerCase();

    var filterdata = allData.filter(
      (item) =>
        item.cleaningWashingNo.includes(filetrtext) ||
        item.employeeName.includes(filetrtext) ||
        item.lotNo.includes(filetrtext)
    );

   setData(filterdata); 
                                
setCurrentPage(1);
  };
  const { sendRequest: cwDelete } = useHttp();

  const [deleteLoading, setDeleteLoading] = useState(false);

  const deleteOperation = (e, cleaningWashingId) => {
    e.preventDefault();
    AntModal.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete these detail?",
      onOk() {
        setDeleteLoading(cleaningWashingId);
        const data = {
          cleaningWashingId: cleaningWashingId,
          serviceId: sId,
        };

        cwDelete(
          {
            url: "/api/cleaningWashing/",
            method: "DELETE",
            body: data,
          },
          (data) => {
            toast.success("Data Deleted Successfully");
            getData();
            setDeleteLoading(false);
          },
          () => {
            setDeleteLoading(false);
          }
        );
      },
      onCancel() {
        setDeleteLoading(false);
      },
    });
  };

  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-3 my-3">Cleaning and Washing</label>
          </div>

          <div className="col-6 text-right">
            {canAdd === "block" && (
              <button
                type="button"
                className="btn  btn-primary mx-3 my-3"
                onClick={() => {
                  addForm(true);
                  sId(serviceId);
                  props.update(false);
                }}
              >
                Add Cleaning Washing
              </button>
            )}
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <div className="row">
                      <div className="col-4"> </div>
                      <div className="col-4"> </div>

                      <div className="col-4">
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                          placeholder="Search..."
                        />
                      </div>
                    </div>
                    <br />
                    <table className="table table-responsive table-bordered text-center">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Time</th>
                          <th>Doc No</th>
                          <th>Assigned Supervisor</th>
                          <th>Lot No</th>
                          <th>Lot Quantity</th>
                          <th>Unit</th>

                          <th>Water Temp.(°C) </th>
                          <th>Detergent in Water</th>

                          <th>Wax Coating</th>
                          <th>Delete</th>

                          {canView === "block" && <th>View</th>}
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i}>
                                <td>{itm.cleaningWashingDate}</td>
                                <td>{itm.cleaningWashingTime}</td>
                                <td>{itm.cleaningWashingNo}</td>
                                <td>{itm.employeeName}</td>
                                <td>{itm.lotNo}</td>
                                <td>{itm.TotalinputWeight}</td>
                                <td>{itm.unitAbbreviation}</td>
                                <td>{itm.waterTemperature}</td>
                                <td>{itm.detergentinWater}</td>
                                <td>{itm.waxCoating}</td>
                                {/* <td>
                                  <button
                                    onClick={() => {
                                      props.addForm(true);
                                      props.update(itm);
                                      props.sId(serviceId)
                                    }}
                                    className="btn"
                                  >
                                    <i className="fas fa-edit"></i>
                                  </button>
                                </td>
                              */}{" "}
                                <td>
                                  {deleteLoading === itm.cleaningWashingId ? (
                                    <Spin />
                                  ) : (
                                    <button
                                      onClick={(e) =>
                                        deleteOperation(e, itm.cleaningWashingId)
                                      }
                                      className="btn"
                                    >
                                      <i className="fa fa-trash"></i>
                                    </button>
                                  )}
                                </td>
                                {canView === "block" && (
                                  <td>
                                    <button
                                      className="btn"
                                      onClick={() => openModal(itm)}
                                    >
                                      <i className="fas fa-eye"></i>
                                    </button>
                                  </td>
                                )}
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Modal isOpen={isModalOpen} style={customModalStyles}>
        {selectedData && (
          <div className="mx-3">
            <div className="">
              <h3 className="card-title">Cleaning Washing Details</h3>
              <div className="card-tools text-right">
                <button
                  type="button"
                  className="btn btn-tool"
                  data-card-widget="remove"
                  onClick={() => setIsModalOpen(false)}
                >
                  <i className="fas fa-times" />
                </button>
                <hr />
              </div>
            </div>
            <div className="row">
              <p className="col-md-6">
                Date: {selectedData.cleaningWashingDate}
              </p>
              <p className="col-md-6">
                Time: {selectedData.cleaningWashingTime}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Doc No: {selectedData.cleaningWashingNo}
              </p>
              <p className="col-md-6">
                Assigned Supervisor: {selectedData.employeeName}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">Lot No: {selectedData.lotNo}</p>
              <p className="col-md-6">
                Lot Quantity: {selectedData.TotalinputWeight}{" "}
                {selectedData.unitAbbreviation}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Product Name: {selectedData.productName}
              </p>
              <p className="col-md-6">
                Water Temperature: {selectedData.waterTemperature}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">Wax Coating: {selectedData.waxCoating}</p>
              <p className="col-md-6">
                Detergent in Water: {selectedData.detergentinWater}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">Labour Hours: {selectedData.labourHrs}</p>
            </div>

            <h5>Water treatment with Fungicidal dipping</h5>
            <div className="row">
              <p className="col-md-6">
                Desired Temperature:{" "}
                {selectedData.waterTreatmentDipping &&
                  selectedData.waterTreatmentDipping.desiredTemp}
              </p>
              <p className="col-md-6">
                Fungicide Concentration:
                {selectedData.waterTreatmentDipping &&
                  selectedData.waterTreatmentDipping.fungicideConcentration}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Fungicide Name:
                {selectedData.waterTreatmentDipping &&
                  selectedData.waterTreatmentDipping.fungicideName}
              </p>
              <p className="col-md-6">
                Exposure time (sec):{" "}
                {selectedData.waterTreatmentDipping &&
                  selectedData.waterTreatmentDipping.exposureTime}
              </p>
            </div>
            <h5 className="card-title">Product Details</h5>
            <table className="table table-sm table-bordered">
              <thead>
                <tr>
                  <th>Sr. No</th>
                  <th>Product Name</th>
                  <th>Item Id</th>
                  <th>Product Sub Type</th>
                  <th>Product Type</th>
                  <th>Quantity</th>
                  <th>Unit</th>
                </tr>
              </thead>
              <tbody>
                {productDetails &&
                  productDetails.map((itm, i) => {
                    return (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{itm.productName}</td>
                        <td>{itm.itemId}</td>
                        <td>{itm.productSubTypeName}</td>
                        <td>{itm.productTypeName}</td>
                        <td>{itm.inputItemQuantity}</td>
                        <td>{itm.unitAbbreviation}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        )}
      </Modal>
    </>
  );
};

export default CleaningWashingListview;
